import { CDropdown, CDropdownMenu, CDropdownToggle } from "@coreui/react";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import React from "react";
import { connect } from "react-redux";
import EnhancedTableHead from "./EnhancedTableHead";
import EnhancedTableToolbar from "./EnhancedTableToolbar";
import { removeArrayDups } from "./helperFunctions";
import PreviousInviteDropdown from "./PreviousInviteDropdown";
import { readableStartEnd } from "../../functions/timeFormat";

const UrgentTable = ({
  placements,
  useStyles,
  checkboxes,
  dispatch,
  userToken,
  employees = [],
}) => {
  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  /* Start datetime | Client company name | location | employee | notify | save  */
  const headCells = [
    { id: "time", numeric: false, disablePadding: true, label: "Time" },
    {
      id: "client",
      numeric: true,
      disablePadding: false,
      label: "Client",
    },
    { id: "location", numeric: true, disablePadding: false, label: "Location" },
    {
      id: "employee",
      numeric: true,
      disablePadding: false,
      label: "Employee",
    },
    {
      id: "previousInvites",
      numeric: true,
      disablePadding: false,
      label: "Previous Invites",
    },
  ];

  const classes = useStyles();

  return (
    <>
      <Paper className={classes.paper}>
        <EnhancedTableToolbar
          numSelected={[]}
          title={"Urgent Placements"}
          checkboxes={checkboxes}
        />
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="medium"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              rowCount={placements.length}
              headCells={headCells}
              checkboxes={checkboxes}
            />
            <TableBody>
              {stableSort(placements, getComparator("asc", "calories")).map(
                (row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {checkboxes ? (
                        <TableCell padding="checkbox">
                          <Checkbox
                            color={"default"}
                            inputProps={{ "aria-labelledby": labelId }}
                            disabled={true}
                          />
                        </TableCell>
                      ) : null}

                      <TableCell
                        component="th"
                        id={labelId}
                        scope="row"
                        padding="none"
                        align="center"
                      >
                        {readableStartEnd(row.start_time, row.end_time)}
                      </TableCell>

                      <TableCell align="center">
                        {row.client.company_name}
                      </TableCell>

                      <TableCell align="center">{row.location}</TableCell>

                      <TableCell align="center">
                        <button type="button" class="btn btn-danger">
                          Unassigned
                        </button>
                      </TableCell>

                      <TableCell align="center" className="text-info">
                        {row.previous_invites ? (
                          <CDropdown className="noPress">
                            <>
                              <CDropdownToggle className="noPress">
                                Previously offered
                              </CDropdownToggle>
                              <CDropdownMenu className="noPress">
                                {removeArrayDups(
                                  row.previous_invites.split(",")
                                ).map((employeeUserId, i) => {
                                  if (employeeUserId) {
                                    var employee = employees.find(
                                      (e) =>
                                        e.user.id === parseInt(employeeUserId)
                                    );
                                    if (employee) {
                                      return (
                                        <PreviousInviteDropdown
                                          employee={employee}
                                          employeeUserId={employeeUserId}
                                          row={row}
                                          userToken={userToken}
                                          dispatch={dispatch}
                                          placements={placements}
                                          key={i}
                                        />
                                      );
                                    }
                                  }
                                  return null;
                                })}
                              </CDropdownMenu>
                            </>
                          </CDropdown>
                        ) : (
                          "No previous invites."
                        )}
                      </TableCell>
                    </TableRow>
                  );
                }
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
};

export default connect()(UrgentTable);
